// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  id: __t.string().primaryKey(),
  orgId: __t.string().name("org_id"),
  kind: __t.string(),
  status: __t.string(),
  pool: __t.string(),
  assetId: __t.string().name("asset_id"),
  projectId: __t.string().name("project_id"),
  title: __t.string(),
  settings: __t.string(),
  progress: __t.f64(),
  workerId: __t.string().name("worker_id"),
  workerName: __t.string().name("worker_name"),
  attempts: __t.u32(),
  createdByUserId: __t.string().name("created_by_user_id"),
  createdByName: __t.string().name("created_by_name"),
  createdAt: __t.timestamp().name("created_at"),
  startedAt: __t.option(__t.timestamp()).name("started_at"),
  finishedAt: __t.option(__t.timestamp()).name("finished_at"),
  heartbeatAt: __t.option(__t.timestamp()).name("heartbeat_at"),
  resultKey: __t.string().name("result_key"),
  resultBytes: __t.f64().name("result_bytes"),
  error: __t.string(),
  priority: __t.u32(),
  billedMinutes: __t.f64().name("billed_minutes"),
  scopeId: __t.string().name("scope_id"),
  parentId: __t.string().name("parent_id"),
});
